import { render, staticRenderFns } from "./RecruitContent.vue?vue&type=template&id=2e4f3462&scoped=true&"
import script from "./RecruitContent.vue?vue&type=script&lang=js&"
export * from "./RecruitContent.vue?vue&type=script&lang=js&"
import style0 from "./RecruitContent.vue?vue&type=style&index=0&id=2e4f3462&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4f3462",
  null
  
)

export default component.exports